var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-field',[_c('md-file',{attrs:{"placeholder":"Seleccionar archivo"},on:{"change":_vm.selectedFile},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Providers/wizard/uploadFile.vue